import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './index.module.scss';
import PopUp from 'components/Operational/PopUp/PopUp';
import staticText from 'static/text_display.json';
import { HelpIcon, SaveIcon, SendIcon } from '../../Icons';
import { useTranslation } from 'react-i18next';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowBackSharpIcon from '@material-ui/icons/ArrowBackSharp';
import IconWithText from 'components/IconWithText/iconWithText';

const useStyles = makeStyles(theme => ({
  headerColor: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.secondary.light,
  },
}));
const FormHeader = ({
  className,
  icon,
  title,
  onClickClose,
  onClickSave,
  isformDirty,
  requireHeaderSaveBtn,
  formInfo,
  saveHoverText,
  useSendIcon,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [confirmPopup, setConfirmPopup] = useState(false);
  const showPopup = () => {
    setConfirmPopup(true);
  };
  const removePopup = () => {
    setConfirmPopup(false);
  };
  /**
   *
   * update the status message and action message with valida one.
   */

  return (
    <>
      <Box
        component={'div'}
        display="flex"
        flexDirection={'row'}
        justifyContent={'space-between'}
        className={classes.headerColor}
      >
        <Box className={cn(className, styles.header)} elevation={0}>
          {icon && (
            <IconWithText
              title={staticText.general.close_form}
              component={ArrowBackSharpIcon}
              onClick={isformDirty ? showPopup : onClickClose}
              theme={'light'}
            />
          )}
          <h2>{t(title)}</h2>
        </Box>
        <Box component={'div'} className={styles.imageContainer}>
          {formInfo && (
            <IconWithText
              title={formInfo?.value}
              component={HelpIcon}
              theme={'light'}
              onClick={
                formInfo?.link
                  ? () =>
                      window.open(
                        formInfo?.link,
                        '_blank',
                        'noopener,noreferrer',
                      )
                  : ''
              }
            />
          )}
          {requireHeaderSaveBtn && (
            <IconWithText
              title={saveHoverText}
              component={useSendIcon ? SendIcon : SaveIcon}
              onClick={onClickSave}
              theme={'light'}
            />
          )}
        </Box>
      </Box>
      {confirmPopup && (
        <PopUp
          title={'dialogue_discard_changes_title'}
          statusMessage={'dialogue_discard_changes_desc'}
          submitBtnText={'dialogue_discard_changes_pos_button'}
          submit={onClickClose}
          cancelBtnText={'dialogue_discard_changes_neg_button'}
          cancel={removePopup}
          close={removePopup}
        />
      )}
    </>
  );
};

FormHeader.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  close: PropTypes.bool,
  icon: PropTypes.bool,
  onClickClose: PropTypes.func,
  onClickSave: PropTypes.func,
  isformDirty: PropTypes.bool,
  requireHeaderSaveBtn: PropTypes.bool,
  formInfo: PropTypes.object,
  saveHoverText: PropTypes.string,
  useSendIcon: PropTypes.bool,
};

export default FormHeader;
